import createReactComponent from '../createReactComponent';
export default createReactComponent('math-avg', 'IconMathAvg', [
  ['path', { d: 'M3 21l18 -18', key: 'svg-0' }],
  ['path', { d: 'M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0', key: 'svg-1' }],
]);
